import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { cloneDeep, get, remove } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, NumberInput, SizeFittingTable } from 'src/components/Antd';
import { OriCheckbox as Checkbox } from 'src/components/Antd/Checkbox/Checkbox';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import DroppableTable from 'src/components/DroppableTable/EditDraggableTable';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Html from 'src/constrains/HtmlToText';
import Tip from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/DisabledSectionTip';
import Action from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import {
  deletePromotion,
  postPromotion,
} from 'src/request/salesChannel/setting/checkout';
import { msg } from 'src/tools/message';
import { EnumTablePosition } from 'src/types/common/common';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import css from './css.module.less';
import Modal from './Modal';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  i18nGet,
  handleOnGetCurrentSCTimezoneUTC,
  handleOnFormatCurrentSCTimeAndDate,
} from 'src/tools/tools';

enum EStatus {
  Active = 'Active',
  Scheduled = 'Scheduled',
}

const qParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  //  salesChannelMultiLanguageUpdate: true,
};

const PromotionBar = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { uuid }: any = useParams();
  const [visible, setVisible] = React.useState(false);

  const { setHasModified, data, onChange, isPrimary, disableEdit } = props;

  const actives = get(data, 'actives', []);

  const schedules = get(data, 'schedules', []);
  const hasContent = actives.length > 0 || schedules.length > 0;

  const scTimezoneUTC = handleOnGetCurrentSCTimezoneUTC();

  const [selected, setSelected] = React.useState(null);
  const handleOnClose = () => {
    setVisible(null);
    setSelected(null);
  };

  const enabled = get(data, 'enabled');
  const barColour = get(data, 'barColour');
  const textColour = get(data, 'textColour');
  const intervalTime = get(data, 'intervalTime');
  const handleHasModified = () => {
    setHasModified(true);
  };

  const handleOnEdit = (obj: any) => {
    setSelected(obj);
    setVisible(true);
  };

  const handleOnPromotionChange = (obj: any) => {
    handleHasModified();
    const isNew = !!!get(obj, 'uuid');
    //
    const _data = cloneDeep(data);
    postPromotion(obj, qParams)
      .then((res: any) => {
        const status = get(res, 'status');
        if (isNew) {
          if (status === EStatus.Active) {
            (_data.actives || []).push(res);
          }
          if (status === EStatus.Scheduled) {
            (_data.schedules || []).push(res);
          }
        } else {
          const preStatus = get(obj, 'status');
          const uuid = get(res, 'uuid');
          if (preStatus === status) {
            if (status === EStatus.Active) {
              _data.actives = (_data.actives || []).map((i) => {
                if (i.uuid === uuid) {
                  return { ...i, ...res };
                }
                return i;
              });
            }
            if (status === EStatus.Scheduled) {
              _data.schedules = (_data.schedules || []).map((i) => {
                if (i.uuid === uuid) {
                  return { ...i, ...res };
                }
                return i;
              });
            }
          } else {
            if (status === EStatus.Active) {
              (_data.actives || []).push(res);
              remove(_data.schedules || [], (x: any) => {
                return x.uuid === uuid;
              });
            }
            if (status === EStatus.Scheduled) {
              (_data.schedules || []).push(res);
              remove(_data.actives || [], (x: any) => {
                return x.uuid === uuid;
              });
            }
          }
        }
        //console.log('_data', _data);
        if (onChange) {
          onChange(_data);
        }
      })
      .then(() => {
        handleOnClose();
        msg.success(
          getI18n('salesChannelCheckout.index.promotionContenthasbeenupdated'),
        );
      });
  };

  const handleOnPromotionDelete = (obj: any) => {
    const uuid = get(obj, 'uuid');
    deletePromotion(uuid, qParams).then((res) => {
      handleHasModified();
      const _data = cloneDeep(data);
      const status = get(obj, 'status');
      if (status === EStatus.Active) {
        remove(_data.actives || [], (x: any) => {
          return x.uuid === uuid;
        });
      }
      if (status === EStatus.Scheduled) {
        remove(_data.schedules || [], (x: any) => {
          return x.uuid === uuid;
        });
      }
      if (onChange) {
        onChange(_data);
        msg.success(
          getI18n('salesChannelCheckout.index.promotionContenthasbeendeleted'),
        );
      }
    });
  };

  const handleOnActiveSort = (e) => {
    handleHasModified();
    const _data = { ...data };
    _data.actives = e;
    if (onChange) {
      onChange(_data);
    }
  };

  const handleOnEnableChange = (e) => {
    handleHasModified();
    const _enabled = e.target.checked;
    const _data = { ...data };
    _data.enabled = _enabled;
    if (onChange) {
      onChange(_data);
    }
  };
  const handleOnBarChange = (barColour) => {
    handleHasModified();
    const _data = { ...data };
    _data.barColour = barColour;
    if (onChange) {
      onChange(_data);
    }
  };
  const handleOnTextChange = (textColour) => {
    handleHasModified();
    const _data = { ...data };
    _data.textColour = textColour;
    if (onChange) {
      onChange(_data);
    }
  };
  const handleOnTimeChange = (intervalTime) => {
    handleHasModified();
    const _data = { ...data };
    _data.intervalTime = intervalTime || 1;
    if (onChange) {
      onChange(_data);
    }
  };
  return (
    <SectionWrapper
      title={getI18n('salesChannelCheckout.index.checkoutPromotionBar')}>
      {visible && (
        <Modal
          isPrimary={isPrimary}
          data={selected}
          salesChannelUuid={uuid}
          onCancel={handleOnClose}
          onOk={handleOnPromotionChange}
          visible={visible}
          scTimezoneUTC={scTimezoneUTC}
        />
      )}
      {isPrimary && (
        <Checkbox
          checked={enabled}
          onChange={handleOnEnableChange}
          disabled={disableEdit}
          className={css.checkbox}>
          {getI18n('salesChannelCheckout.index.enablecheckoutpromotionbar')}
        </Checkbox>
      )}
      {!enabled && !isPrimary && (
        <Tip
          className={css.containerClassName}
          tip={getI18n(
            'salesChannelCheckout.index.enablecheckoutpromotionbartip',
          )}
        />
      )}
      {enabled && (
        <React.Fragment>
          {isPrimary && (
            <div className={css.colorContainer}>
              <ItemWrapper
                title={getI18n('salesChannelCheckout.index.promotionBarColour')}
                containerClassName={css.barContainerClassName}>
                <ColorPicker
                  multi
                  onChange={handleOnBarChange}
                  color={barColour}
                  disable={disableEdit}
                />
              </ItemWrapper>
              <ItemWrapper
                title={getI18n('salesChannelCheckout.index.textColour')}
                containerClassName={css.barContainerClassName}>
                <ColorPicker
                  multi
                  onChange={handleOnTextChange}
                  color={textColour}
                  disable={disableEdit}
                />
              </ItemWrapper>
            </div>
          )}

          <SizeFittingTable
            data={[]}
            rowKey='uuid'
            columns={titleCol(scTimezoneUTC, { getI18n })}
            pagination={false}
            className={css.noTitleTable}
            id='SalesChannelSettingCheckoutPromotionTitle'
          />
          {hasContent ? (
            <React.Fragment>
              <div className={css.sectionTitle}>
                {getI18n('general.status.active')}
              </div>
              {/* {actives.length === 0 && <Empty description={'No Active Promotion'} />} */}
              <DroppableTable
                hideAllDragHandlers={disableEdit}
                // rowSelection
                columns={activeCol(
                  isPrimary,
                  handleOnEdit,
                  handleOnPromotionDelete,
                  disableEdit,
                  scTimezoneUTC,
                  { getI18n, handleOnFormatCurrentSCTimeAndDate },
                )}
                showHeader={false}
                pagination={false}
                rowKey={'uuid'}
                id='SalesChannelSettingCheckoutPromotionActive'
                dataSource={actives}
                onTableChange={handleOnActiveSort}
              />
              <div className={css.sectionTitle}>
                {getI18n('general.status.scheduled')}
              </div>
              <SizeFittingTable
                dataSource={schedules}
                rowKey='uuid'
                showHeader={false}
                columns={scheduleCol(
                  isPrimary,
                  handleOnEdit,
                  handleOnPromotionDelete,
                  disableEdit,
                  scTimezoneUTC,
                  { getI18n, handleOnFormatCurrentSCTimeAndDate },
                )}
                pagination={false}
                //className={css.noTitleTable}
                id='SalesChannelSettingCheckoutPromotionSchedules'
              />
            </React.Fragment>
          ) : (
            <div className={css.noContentTip}>
              {getI18n(
                'salesChannelCheckout.index.thereisnocheckoutpromotioncontent',
              )}
            </div>
          )}
          {!isPrimary && (
            <Tip
              className={css.btnTip}
              tip={getI18n('salesChannelCheckout.index.addpromotiontip')}
            />
          )}
          {isPrimary && (
            <React.Fragment>
              <Button
                onClick={() => {
                  handleOnEdit({});
                }}
                type='primary'
                className={css.addNew}
                disabled={disableEdit}>
                {getI18n('salesChannelCheckout.index.addPromotionContent')}
              </Button>
              <ItemWrapper
                containerClassName={css.barContainerClassName}
                title={getI18n('salesChannelCheckout.index.intervalTime')}>
                <NumberInput
                  min={1}
                  suffix={getI18n('salesChannelCheckout.index.seconds')}
                  //className={}
                  value={intervalTime}
                  size='large'
                  onChange={handleOnTimeChange}
                  disabled={disableEdit}
                />
              </ItemWrapper>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </SectionWrapper>
  );
};
export default PromotionBar;
const noDragWidth = {
  content: 512,
  start: 180,
  end: 180,
  action: 180,
};
const withDragWidth = {
  content: 512 - 24,
  start: 180,
  end: 180,
  action: 180,
};
// const format = (time) => {
//   return moment(time).format('DD MMM YYYY HH:mm');
// };
const activeCol = (
  isPrimary,
  onEdit,
  onDelete,
  disableEdit,
  scTimezoneUTC,
  { getI18n, handleOnFormatCurrentSCTimeAndDate },
) => {
  return [
    {
      title: getI18n('salesChannelCheckout.index.promotionContent'),
      minWidth: withDragWidth.content,
      key: 'content',
      default: true,
      childGenerate: (a, record) => {
        const content = get(record, 'content');

        return (
          <Html html={content} hasTooltip width={withDragWidth.content - 100} />
        );
      },
    },
    {
      title: `${getI18n(
        'salesChannelCheckout.index.startTime',
      )} (UTC ${scTimezoneUTC})`,
      width: withDragWidth.start,
      key: 'start',
      default: true,
      childGenerate: (a, record) => {
        const startTime = get(record, 'startTime');
        let display = getI18n('salesChannelCheckout.index.noStartTime');
        if (startTime) {
          display = handleOnFormatCurrentSCTimeAndDate(startTime);
        }
        //|| 'No Start Time';
        return (
          <NoWrapContainer>
            <GlobalTooltip title={display}>{display}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      title: getI18n('salesChannelCheckout.index.endTime'),
      width: 180,
      key: withDragWidth.end,
      default: true,
      childGenerate: (a, record) => {
        const endTime = get(record, 'endTime');
        let display = getI18n('salesChannelCheckout.index.noEndTime');
        if (endTime) {
          display = handleOnFormatCurrentSCTimeAndDate(endTime);
        }
        return (
          <NoWrapContainer>
            <GlobalTooltip title={display}>{display}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
    },
    disableEdit
      ? {}
      : {
          titleGenerate: () =>
            getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            ),
          position: EnumTablePosition.mid,
          width: withDragWidth.action,
          key: 'action',
          default: true,
          childGenerate: (a, record, index) => {
            // const endTime = get(record, 'endTime');
            return (
              <Action
                {...(isPrimary
                  ? {
                      onDelete: () => {
                        onDelete(record);
                      },
                    }
                  : {})}
                onEdit={() => {
                  onEdit(record, index);
                }}
              />
            );
          },
        },
  ];
};

const scheduleCol = (
  isPrimary,
  onEdit,
  onDelete,
  disableEdit,
  scTimezoneUTC,
  { getI18n, handleOnFormatCurrentSCTimeAndDate },
) => {
  return [
    {
      title: getI18n('salesChannelCheckout.index.promotionContent'),
      minWidth: noDragWidth.content,
      key: 'content',
      default: true,
      childGenerate: (a, record) => {
        const content = get(record, 'content');

        return (
          <Html html={content} hasTooltip width={noDragWidth.content - 100} />
          // <NoWrapContainer>
          //   <GlobalTooltip title={content}>{content}</GlobalTooltip>
          // </NoWrapContainer>
        );
      },
    },
    {
      title: `${getI18n(
        'salesChannelCheckout.index.startTime',
      )} (UTC ${scTimezoneUTC})`,
      width: noDragWidth.start,
      key: 'start',
      default: true,
      childGenerate: (a, record) => {
        const startTime = get(record, 'startTime');
        let display = getI18n('salesChannelCheckout.index.noStartTime');
        if (startTime) {
          display = handleOnFormatCurrentSCTimeAndDate(startTime);
        }
        return (
          <NoWrapContainer>
            <GlobalTooltip title={display}>{display}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      title: getI18n('salesChannelCheckout.index.endTime'),
      width: 180,
      key: noDragWidth.end,
      default: true,
      childGenerate: (a, record) => {
        const endTime = get(record, 'endTime');
        let display = getI18n('salesChannelCheckout.index.noEndTime');
        if (endTime) {
          display = handleOnFormatCurrentSCTimeAndDate(endTime);
        }
        return (
          <NoWrapContainer>
            <GlobalTooltip title={display}>{display}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
    },
    disableEdit
      ? {}
      : {
          titleGenerate: () =>
            getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            ),
          position: EnumTablePosition.mid,
          width: noDragWidth.action,
          key: 'action',
          default: true,
          childGenerate: (a, record, index) => {
            // const endTime = get(record, 'endTime');
            return (
              <Action
                {...(isPrimary
                  ? {
                      onDelete: () => {
                        onDelete(record);
                      },
                    }
                  : {})}
                onEdit={() => {
                  onEdit(record, index);
                }}
              />
            );
          },
        },
  ];
};

const titleCol = (scTimezoneUTC, { getI18n }) => [
  {
    title: getI18n('salesChannelCheckout.index.promotionContent'),
    minWidth: noDragWidth.content,
    key: 'content',
    default: true,
    render: () => {
      return null;
    },
  },
  {
    title: `${getI18n(
      'salesChannelCheckout.index.startTime',
    )} (UTC ${scTimezoneUTC})`,
    width: noDragWidth.start,
    key: 'start',
    default: true,
    render: () => {
      return null;
    },
  },
  {
    title: `${getI18n(
      'salesChannelCheckout.index.endTime',
    )} (UTC ${scTimezoneUTC})`,
    width: 180,
    key: noDragWidth.end,
    default: true,
    render: () => {
      return null;
    },
  },
  {
    titleGenerate: () =>
      getI18n('general.advancedFilters.commonStoreProductsWithTable.actions'),
    position: EnumTablePosition.mid,
    width: noDragWidth.action,
    key: 'action',
    default: true,
    render: () => {
      return null;
    },
  },
];
